export let Plans = /*#__PURE__*/function (Plans) {
  Plans["Lite"] = "Lite";
  Plans["Starter"] = "Starter";
  Plans["Professional"] = "Professional";
  Plans["Enterprise"] = "Enterprise";
  return Plans;
}({});
export const PLANS = Plans;
export let PlanFeature = /*#__PURE__*/function (PlanFeature) {
  PlanFeature["POS_BASIC"] = "pos_basic";
  PlanFeature["BARCODE_PRINT"] = "barcode_print";
  PlanFeature["SCALE_DEVICE"] = "scale_device";
  PlanFeature["INVENTORY"] = "inventory";
  PlanFeature["GOLD_PRICE"] = "gold_price";
  PlanFeature["BULK_PRINT"] = "bulk_print";
  PlanFeature["REPORT_BASIC"] = "report_basic";
  PlanFeature["REPORT_ADVANCED"] = "report_advanced";
  PlanFeature["REPORT_CUSTOM"] = "report_custom";
  PlanFeature["E_INVOICE"] = "e_invoice";
  PlanFeature["MISA_SYNC"] = "misa_sync";
  PlanFeature["API_ACCESS"] = "api_access";
  PlanFeature["MULTI_BRANCH"] = "multi_branch";
  PlanFeature["SUPPORT_247"] = "support_247";
  // Payroll module (EG-504) — gated từ Starter (per FE planSlice).
  PlanFeature["PAYROLL"] = "payroll";
  // active in all plans
  PlanFeature["CRM"] = "crm";
  PlanFeature["HARDWARE_PLUGIN"] = "hardware_plugin";
  PlanFeature["CUSTOM_BRANDING"] = "custom_branding";
  PlanFeature["WEBHOOK"] = "webhook";
  PlanFeature["REFERRAL"] = "referral";
  return PlanFeature;
}({});
export let PlanLimitType = /*#__PURE__*/function (PlanLimitType) {
  PlanLimitType["STORES"] = "stores";
  PlanLimitType["USERS"] = "users";
  PlanLimitType["PRODUCTS"] = "products";
  return PlanLimitType;
}({});
export let PlanFeatureCategory = /*#__PURE__*/function (PlanFeatureCategory) {
  PlanFeatureCategory["POS"] = "pos";
  PlanFeatureCategory["INVENTORY"] = "inventory";
  PlanFeatureCategory["GOLD"] = "gold";
  PlanFeatureCategory["REPORT"] = "report";
  PlanFeatureCategory["CRM"] = "crm";
  PlanFeatureCategory["INTEGRATION"] = "integration";
  PlanFeatureCategory["SYSTEM"] = "system";
  return PlanFeatureCategory;
}({});

/** @deprecated Use PlanFeature directly */
export const Feature = PlanFeature;
/** @deprecated Use PlanFeature directly */

/** @deprecated Use PlanLimitType directly */
export const LimitType = PlanLimitType;
/** @deprecated Use PlanLimitType directly */

/** @deprecated Use PlanFeatureCategory directly */
export const FeatureCategory = PlanFeatureCategory;
/** @deprecated Use PlanFeatureCategory directly */
//# sourceMappingURL=plan.enum.js.map